import * as React from 'react';

export enum LoadingSize {
	DEFAULT = 'default',
	SMALL = 'small',
}

interface LoadingProps {
	absolute?: boolean;
	size?: LoadingSize;
	white?: boolean;
}

const Loading: React.FC<LoadingProps> = ({
	absolute,
	size = LoadingSize.DEFAULT,
	white = false,
}) => {
	const loader = (
		<div className='sk-circle'>
			{[...Array(12)].map((x, i) => (
				<div className={`sk-circle${i + 1} sk-child`} key={i} />
			))}
		</div>
	);

	if (size === LoadingSize.SMALL) {
		return (
			<div
				className='sk-circle'
				style={{ height: '25px', width: '25px', margin: 0 }}>
				{[...Array(12)].map((_, i) => (
					<div
						className={`sk-circle${i + 1} sk-child ${white ? 'white' : ''}`}
						key={i}
					/>
				))}
			</div>
		);
	}

	if (absolute) {
		return (
			<div
				style={{
					position: 'absolute',
					left: 0,
					right: 0,
					top: 0,
					bottom: 0,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					backgroundColor: 'rgba(255,255,255,.6)',
				}}>
				{loader}
			</div>
		);
	}

	return loader;
};

export default Loading;
